import { Close } from "@mui/icons-material";
import { Box, Button, IconButton, Modal, Typography } from "@mui/material";
import React from "react";

const ConfirmDialog = ({
  title,
  message,
  showDeleteModal,
  setShowDeleteModal,
  onDelete,
}: {
  title: string;
  message: string;
  showDeleteModal: boolean;
  setShowDeleteModal: React.Dispatch<React.SetStateAction<boolean>>;
  onDelete: () => void;
}) => {
  return (
    <Modal open={showDeleteModal} onClose={() => setShowDeleteModal(false)}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 500, // Adjust width as needed
          maxHeight: "80vh", // Limit the height of the modal
          bgcolor: "background.paper",
          border: "2px solid #000",
          boxShadow: 24,
          p: 3,
          overflowY: "auto", // Make the content scrollable on the Y-axis
          borderRadius: 2,
        }}
      >
        <Box display="flex" justifyContent="space-between" mb={2}>
          <Typography variant="h6" component="h2">
            {title}
          </Typography>
          <IconButton onClick={() => setShowDeleteModal(false)}>
            <Close />
          </IconButton>
        </Box>
        <Typography variant="body1">
          {message}
        </Typography>
        <div className="mt-8 flex justify-end">
          <Button
            onClick={onDelete}
            color="primary"
            variant="contained"
            sx={{
              mr: 1,
            }}
          >
            Yes
          </Button>
          <Button onClick={() => setShowDeleteModal(false)}>No</Button>
        </div>
      </Box>
    </Modal>
  );
};

export default ConfirmDialog;
